import { formattedNumber } from "@/utils/string"

export function formattedMoney(value: number | null, currency: string | null): string | null {
  if (value == null) return null

  const currencySymbols: Record<string, string> = {
    usd: "$",
    krw: "₩",
    cny: "¥",
  }

  const formatted = formattedNumber(value)

  if (currency) {
    const symbol = currencySymbols[currency.toLowerCase()]
    if (symbol) {
      return symbol + " " + formatted
    }
  }

  return formatted
}

export function minimumUnit(currency: string | null): number {
  if (!currency) return 1

  if (currency.toLowerCase() === "krw") {
    return 1
  } else {
    return 0.01
  }
}
